export default __webpack_public_path__ + "src/images/packages/simbambili-lodge/cd5aa2b7ffcc41a8a2eeda755e9336f6-1.jpg";